import React from 'react'
import MobileDrawer from '../MobileComponents/MobileDrawer'
import resipro from '../../assets/images/resiproIcon.svg'

function MobileMyOrder() {
  // https://harshuveg.com/
  return (
    <div className='mainwrapperView'>
    <div className="drawerWithTop">
        <MobileDrawer />
        <div className="EventTimeView">
          <img src={resipro} className="HeaderlogoImage" alt='altimg'/>
          <h2 className="mobHeadHeading">Park Side Apartment</h2>
        </div>
    </div>
      <div className='topSpace'></div>
      
    </div>
  )
}

export default MobileMyOrder